'use client'

import { SessionProvider } from "next-auth/react"
import { AppContextProvider } from "@/helpers/context/AppContext"

export default function Providers({ children }) {
  return (
    // <SessionProvider>
      <AppContextProvider>
        {children}
      </AppContextProvider>
    // </SessionProvider>
  )
}